import { ref } from 'vue';

/**
 * 발행사 관리 컴포저블
 * 발행사 카드의 UI 상태와 등급별 색상 관리
 */
export function useIssuerManagement() {
  // 모달 상태 관리
  const modals = ref({
    create: false,
    edit: false,
    addAlias: false,
  });

  // 선택된 발행사
  const selectedIssuer = ref(null);

  // 등급별 색상 매핑
  const gradeColorMap = {
    'AAA': 'from-emerald-500 to-emerald-600',
    'AA+': 'from-emerald-400 to-emerald-500',
    'AA': 'from-emerald-400 to-emerald-500',
    'AA-': 'from-emerald-300 to-emerald-400',
    'A+': 'from-blue-500 to-blue-600',
    'A': 'from-blue-400 to-blue-500',
    'A-': 'from-blue-300 to-blue-400',
    'BBB+': 'from-yellow-500 to-yellow-600',
    'BBB': 'from-yellow-400 to-yellow-500',
    'BBB-': 'from-yellow-300 to-yellow-400',
    'BB+': 'from-orange-500 to-orange-600',
    'BB': 'from-orange-400 to-orange-500',
    'BB-': 'from-orange-300 to-orange-400',
    'B+': 'from-red-500 to-red-600',
    'B': 'from-red-400 to-red-500',
    'B-': 'from-red-300 to-red-400',
  };

  // 등급별 색상 클래스 반환
  const getGradeColorClass = (grade) => {
    return gradeColorMap[grade] || 'from-gray-400 to-gray-500';
  };

  // 모달 열기
  const openModal = (modalName, issuer = null) => {
    modals.value[modalName] = true;
    if (issuer) {
      selectedIssuer.value = { ...issuer }; // 객체 복사하여 참조 문제 방지
    } else {
      selectedIssuer.value = null;
    }
  };

  // 모달 닫기
  const closeModal = (modalName) => {
    modals.value[modalName] = false;
    if (modalName === 'edit' || modalName === 'addAlias') {
      selectedIssuer.value = null;
    }
  };

  return {
    modals,
    selectedIssuer,
    getGradeColorClass,
    openModal,
    closeModal,
  };
} 